{
  "navigationRoutes": {
    "openCategory": "Open category",
    "visit": "Visit"
  },
  "auth": {
    "agree": "I agree to",
    "createAccount": "Create account",
    "createNewAccount": "Create New Account",
    "email": "Email",
    "login": "Login",
    "login_success": "You've successfully logged in",
    "login_error": "Invalid email or password",
    "password": "Password",
    "recover_password": "Recover password",
    "keep_logged_in": "Keep me logged in",
    "termsOfUse": "Terms of Use.",
    "reset_password": "Reset password"
  },
  "404": {
    "title": "This page’s gone fishing.",
    "text": "If you feel that it’s not right, please send us a message at ",
    "back_button": "Back to dashboard"
  },
  "typography": {
    "primary": "Primary text styles",
    "secondary": "Secondary text styles"
  },
  "dashboard": {
    "versions": "Versions",
    "setupRemoteConnections": "Setup Remote Connections",
    "currentVisitors": "Current Visitors",
    "navigationLayout": "navigation layout",
    "topBarButton": "Top Bar",
    "sideBarButton": "Side Bar",
    "summaryError": "Could not load the summary",
    "metrics": {
      "pendingBalance": "Total pending balance",
      "paidThisMonth": "Paid this month",
      "overdue": "Overdue invoices",
      "scheduledUpcoming": "Upcoming scheduled payments"
    },
    "byStatus": {
      "title": "Invoices by status",
      "empty": "No invoices with an outstanding balance.",
      "total": "Total"
    },
    "cashflow": {
      "title": "Cash flow",
      "scheduled": "Scheduled",
      "executed": "Executed",
      "range": "Last {days} days",
      "loadError": "Could not load cash flow data",
      "empty": "No cash flow data for this range."
    },
    "overdue": {
      "title": "Overdue invoices",
      "viewAll": "View all",
      "empty": "No overdue invoices. 🎉",
      "loadError": "Could not load overdue invoices"
    },
    "inventoryValue": {
      "title": "Inventory value",
      "loadError": "Could not load the inventory value",
      "trendStart": "Start",
      "trendLoadError": "Could not load the inventory trend"
    }
  },
  "language": {
    "brazilian_portuguese": "Português",
    "english": "English",
    "spanish": "Spanish",
    "simplified_chinese": "Simplified Chinese",
    "persian": "Persian"
  },
  "menu": {
    "buttons": "Buttons",
    "timelines": "Timelines",
    "dashboard": "Dashboard",
    "preferences": "Account preferences",
    "settings": "Application settings",
    "settingsGeneral": "General",
    "posSyncStatus": "POS Sync Status",
    "recover-password-email": "Recover password email",
    "users": "Users",
    "providers": "Providers",
    "cartera": "Portfolio",
    "invoices": "Invoices",
    "paymentSchedules": "Payment Schedules",
    "planilla": "Payment Roster",
    "inventario": "Inventory",
    "tarjetasRegalo": "Gift Cards",
    "programaPuntos": "Loyalty Program",
    "clientesPuntos": "Customers",
    "premios": "Rewards",
    "configuracionPuntos": "Settings",
    "pointOfSale": "Point of Sale",
    "precios": "Pricing",
    "categorias": "Categories",
    "codigosBarra": "Barcodes"
  },
  "messages": {
    "all": "See all messages",
    "new": "New messages from {name}",
    "mark_as_read": "Mark As Read"
  },
  "navbar": {
    "messageUs": "Web development inquiries:",
    "repository": "GitHub Repo"
  },
  "notifications": {
    "all": "See all notifications",
    "less": "See less notifications",
    "mark_as_read": "Mark as read",
    "sentMessage": "sent you a message",
    "uploadedZip": "uploaded a new Zip file with {type}",
    "startedTopic": "started a new topic",
    "markAllRead": "Mark all as read",
    "markAllReadSuccess": "All notifications have been marked as read",
    "markAllReadError": "Could not mark all notifications as read",
    "markReadError": "Could not mark the notification as read",
    "loadError": "Could not load notifications",
    "empty": "You have no notifications",
    "type": {
      "due_soon": "Due soon",
      "overdue": "Overdue"
    }
  },
  "user": {
    "language": "Change language",
    "logout": "Logout",
    "profile": "Profile",
    "settings": "Settings",
    "account": "Account"
  },
  "treeView": {
    "basic": "Basic",
    "icons": "Icons",
    "selectable": "Selectable",
    "editable": "Editable",
    "advanced": "Advanced"
  },
  "chat": {
    "title": "Chat",
    "sendButton": "Send"
  },
  "spacingPlayground": {
    "value": "Value",
    "margin": "Margin",
    "padding": "Padding"
  },
  "spacing": {
    "title": "Spacing"
  },
  "cards": {
    "cards": "Cards",
    "fixed": "Fixed",
    "floating": "Floating",
    "contentText": "The unique stripes of zebras make them one of the animals most familiar to people.",
    "contentTextLong": "The unique stripes of zebras make them one of the animals most familiar to people. They occur in a variety of habitats, such as grasslands, savannas, woodlands, thorny scrublands, mountains, and coastal hills. Various anthropogenic factors have had a severe impact on zebra populations, in particular hunting for skins and habitat destruction. Grévy's zebra and the mountain zebra are endangered. While plains zebras are much more plentiful, one subspecies, the quagga.",
    "rowHeight": "Row height",
    "title": {
      "default": "Default",
      "withControls": "With controls",
      "customHeader": "Custom header",
      "withoutHeader": "Without header",
      "withImage": "With Image",
      "withTitleOnImage": "With title on image",
      "withCustomTitleOnImage": "With custom title on image",
      "withStripe": "With stripe",
      "withBackground": "With background"
    },
    "button": {
      "main": "Main",
      "cancel": "Cancel",
      "showMore": "Show More",
      "readMore": "Show More"
    },
    "link": {
      "edit": "Edit",
      "setAsDefault": "Set as default",
      "delete": "Delete",
      "traveling": "Traveling",
      "france": "France",
      "review": "Review",
      "feedback": "Leave feedback",
      "readFull": "Read full article",
      "secondaryAction": "Secondary action",
      "action1": "Action 1",
      "action2": "Action 2"
    }
  },
  "colors": {
    "themeColors": "Theme Colors",
    "extraColors": "Extra Colors",
    "gradients": {
      "basic": {
        "title": "Button Gradients"
      },
      "hovered": {
        "title": "Hovered Button Gradients",
        "text": "Lighten 15% applied to an original style (gradient or flat color) for hover state."
      },
      "pressed": {
        "title": "Pressed Button Gradients",
        "text": "Darken 15% applied to an original style (gradient or flat color) for pressed state."
      }
    }
  },
  "tabs": {
    "alignment": "Tabs alignment",
    "overflow": "Tabs overflow",
    "hidden": "Tabs with hidden slider",
    "grow": "Tabs grow"
  },
  "search": {
    "placeholder": "Search..."
  },
  "buttonSelect": {
    "dark": "Dark",
    "light": "Light"
  },
  "vuestic": {
    "search": "Search",
    "noOptions": "Items not found",
    "ok": "OK",
    "cancel": "Cancel",
    "uploadFile": "Upload file",
    "undo": "Undo",
    "dropzone": "Drop files here to upload",
    "fileDeleted": "File deleted",
    "closeAlert": "close alert",
    "backToTop": "back to top",
    "toggleDropdown": "toggle dropdown",
    "carousel": "carousel",
    "goPreviousSlide": "go previous slide",
    "goNextSlide": "go next slide",
    "goSlide": "go slide {index}",
    "slideOf": "slide {index} of {length}",
    "close": "close",
    "openColorPicker": "open color picker",
    "colorSelection": "color selection",
    "colorName": "color {color}",
    "decreaseCounter": "decrease counter",
    "increaseCounter": "increase counter",
    "selectAllRows": "select all rows",
    "sortColumnBy": "sort column by {name}",
    "selectRowByIndex": "select row {index}",
    "resetDate": "reset date",
    "nextPeriod": "next period",
    "switchView": "switch view",
    "previousPeriod": "previous period",
    "removeFile": "remove file",
    "reset": "reset",
    "pagination": "pagination",
    "goToTheFirstPage": "go to the first page",
    "goToPreviousPage": "go to the previous page",
    "goToSpecificPage": "go to the {page} page",
    "goToSpecificPageInput": "enter the page number to go",
    "goNextPage": "go next page",
    "goLastPage": "go last page",
    "currentRating": "current rating {value} of {max}",
    "voteRating": "vote rating {value} of {max}",
    "optionsFilter": "options filter",
    "splitPanels": "split panels",
    "movePaginationLeft": "move pagination left",
    "movePaginationRight": "move pagination right",
    "resetTime": "reset time",
    "closeToast": "close toast",
    "selectedOption": "Selected option",
    "noSelectedOption": "Option is not selected",
    "breadcrumbs": "breadcrumbs",
    "counterValue": "counter value",
    "selectedDate": "selected date",
    "selectedTime": "selected time",
    "progressState": "progress state",
    "color": "color",
    "next": "Next",
    "back": "Previous",
    "finish": "Finish",
    "step": "step",
    "progress": "progress",
    "loading": "Loading",
    "sliderValue": "Current slider value is {value}",
    "switch": "Switch",
    "inputField": "Input field",
    "fileTypeIncorrect": "File type is incorrect",
    "select": "Select an option"
  },
  "validation": {
    "required": "This field is required",
    "email": "Please enter a valid email address",
    "positiveAmount": "Amount must be greater than 0",
    "dueDateNotBeforeIssueDate": "Due date must be on or after the issue date",
    "providerCode": "Must be exactly 3 numeric digits",
    "positiveInteger": "Must be a whole number of 1 or more"
  },
  "common": {
    "cancel": "Cancel",
    "save": "Save",
    "add": "Add",
    "edit": "Edit",
    "delete": "Delete",
    "back": "Back",
    "resultsCount": "{count} results.",
    "unsavedChangesMessage": "Form has unsaved changes. Are you sure you want to close it?"
  },
  "providers": {
    "pageTitle": "Providers",
    "searchPlaceholder": "Search by name",
    "activeOnlyLabel": "Active only",
    "newButton": "New provider",
    "addTitle": "Add provider",
    "editTitle": "Edit provider",
    "deleteConfirmTitle": "Delete provider",
    "deleteConfirmMessage": "Are you sure you want to delete {name}?",
    "createdToast": "{name} has been created",
    "updatedToast": "{name} has been updated",
    "deletedToast": "{name} has been deleted",
    "loadError": "Could not load providers",
    "saveError": "Could not save the provider",
    "deleteError": "Could not delete the provider",
    "table": {
      "code": "Code",
      "name": "Name",
      "taxId": "Tax ID",
      "defaultMargin": "Margin",
      "contact": "Contact",
      "email": "Email",
      "phone": "Phone",
      "invoices": "Invoices",
      "status": "Status",
      "active": "Active",
      "inactive": "Inactive",
      "editAriaLabel": "Edit provider",
      "deleteAriaLabel": "Delete provider"
    },
    "form": {
      "code": "Code",
      "codeHint": "3 numeric digits, e.g.: 001",
      "name": "Name",
      "taxId": "Tax ID / NIT",
      "contactName": "Contact name",
      "email": "Email",
      "phone": "Phone",
      "defaultMargin": "Sale margin (%)",
      "defaultMarginHint": "Used to calculate the sale price in Pricing",
      "notes": "Notes",
      "active": "Active"
    }
  },
  "precios": {
    "pageTitle": "Pricing",
    "categoryLabel": "Category",
    "formTitle": "Calculate price",
    "form": {
      "reference": "Reference",
      "labelDetail": "Product description",
      "labelDetailPlaceholder": "Long-sleeve shirt",
      "quantity": "Unit quantity",
      "quantityPlaceholder": "12",
      "costPrice": "Cost price",
      "includesIva": "Does the cost already include VAT?"
    },
    "result": {
      "ivaIncluded": "VAT included",
      "ivaNotIncluded": "VAT not included"
    },
    "invoiceFlow": {
      "invoiceLabel": "Invoice",
      "invoiceSearchPlaceholder": "Search by invoice number",
      "providerLabel": "Provider",
      "balancePrefix": "Balance",
      "selectInvoicePrompt": "Select an invoice to add products to its detail.",
      "loadInvoicesError": "Could not load invoices",
      "addToListButton": "Add to list",
      "pendingTitle": "Products added to this invoice",
      "removePendingAriaLabel": "Remove from list",
      "saveAllButton": "Save products to the invoice",
      "savedAllToast": "{count} products saved to the invoice",
      "saveAllError": "Not all products could be saved ({count} saved before the error) — check the message and try again with the rest"
    },
    "historyTitle": "Price history",
    "table": {
      "category": "Category",
      "reference": "Reference",
      "barcode": "Barcode",
      "labelDetail": "Description",
      "quantity": "Quantity",
      "costPrice": "Cost",
      "iva": "VAT",
      "margin": "Margin",
      "salePrice": "Sale price",
      "updatedAt": "Last updated",
      "deleteAriaLabel": "Delete price"
    },
    "emptyHistory": "This provider doesn't have any calculated prices yet.",
    "deletedToast": "Price for {reference} deleted",
    "deleteConfirmTitle": "Delete price",
    "deleteConfirmMessage": "Are you sure you want to delete the price for {reference}?",
    "loadError": "Could not load the price history",
    "deleteError": "Could not delete the price"
  },
  "categorias": {
    "pageTitle": "Categories",
    "newButton": "New category",
    "addTitle": "Add category",
    "editTitle": "Edit category",
    "deleteConfirmTitle": "Delete category",
    "deleteConfirmMessage": "Are you sure you want to delete the category {name}?",
    "createdToast": "{name} has been created",
    "updatedToast": "{name} has been updated",
    "deletedToast": "{name} has been deleted",
    "loadError": "Could not load categories",
    "saveError": "Could not save the category",
    "deleteError": "Could not delete the category",
    "empty": "No categories have been created yet.",
    "table": {
      "name": "Name",
      "code": "Code",
      "editAriaLabel": "Edit category",
      "deleteAriaLabel": "Delete category"
    },
    "form": {
      "name": "Name",
      "code": "Code",
      "codeHint": "3 numeric digits, e.g.: 001"
    }
  },
  "codigosBarra": {
    "pageTitle": "Barcodes",
    "providerLabel": "Provider",
    "categoryFilterLabel": "Category (optional)",
    "selectProviderPrompt": "Select a provider to see its products.",
    "selectAllLabel": "Select all",
    "quantityLabel": "Quantity",
    "printButton": "Print {count} labels",
    "printZebraButton": "Print with Zebra ({count})",
    "printBrowserButton": "Print (browser, fallback)",
    "printBusinessName": "Sinutech Pagos",
    "selectProductAriaLabel": "Select {reference}",
    "empty": "This provider has no products with a category assigned. Assign a category from Pricing so they show up here.",
    "loadError": "Could not load products",
    "zebraPrintSuccess": "{count} labels sent to the Zebra printer.",
    "zebraNotReady": "Printer not ready: {reason}",
    "zebraPrintTimeout": "The printer took longer than expected to respond. {sent} of {total} labels were sent before this happened — check the printer before trying again, so you don't reprint the ones that already went through.",
    "zebraConnectionError": "Couldn't connect to Zebra Browser Print. Make sure the app is installed and running, or use the fallback button."
  },
  "cartera": {
    "pageTitle": "Portfolio",
    "searchPlaceholder": "Search provider",
    "balanceLabel": "Outstanding balance",
    "emptyList": "No providers to show.",
    "noResults": "No providers found.",
    "loadError": "Could not load the portfolio",
    "backButton": "Back to Portfolio",
    "taxId": "Tax ID",
    "summary": {
      "totalInvoiced": "Total invoiced",
      "totalPaid": "Total paid",
      "totalBalance": "Outstanding balance"
    },
    "transactionsTitle": "Transaction history",
    "table": {
      "date": "Date",
      "type": "Type",
      "invoiceNumber": "Invoice #",
      "description": "Description",
      "debit": "Debit",
      "credit": "Credit",
      "balance": "Balance"
    },
    "type": {
      "compra": "Purchase",
      "pago": "Payment"
    },
    "emptyTransactions": "No transactions recorded.",
    "detailLoadError": "Could not load the provider's account statement"
  },
  "invoices": {
    "pageTitle": "Invoices",
    "statusPlaceholder": "Status",
    "allStatuses": "All statuses",
    "providerPlaceholder": "Provider",
    "overdueOnlyLabel": "Overdue only",
    "excludedOnlyLabel": "Show excluded from alerts",
    "discountsOrPriorityOnlyLabel": "Show only discount or priority",
    "newButton": "New invoice",
    "addTitle": "Add invoice",
    "editTitle": "Edit invoice",
    "deleteConfirmTitle": "Delete invoice",
    "deleteConfirmMessage": "Are you sure you want to delete invoice {number}?",
    "createdToast": "Invoice {number} has been created",
    "updatedToast": "Invoice {number} has been updated",
    "deletedToast": "Invoice {number} has been deleted",
    "loadError": "Could not load invoices",
    "saveError": "Could not save the invoice",
    "deleteError": "Could not delete the invoice",
    "status": {
      "pendiente": "Pending",
      "parcial": "Partial",
      "pagada": "Paid",
      "vencida": "Overdue"
    },
    "table": {
      "number": "Invoice #",
      "provider": "Provider",
      "issueDate": "Issue date",
      "dueDate": "Due date",
      "amount": "Amount",
      "balance": "Balance",
      "status": "Status",
      "overdueTooltip": "Past due date",
      "excludedFromAlertsTooltip": "Excluded from overdue alerts",
      "discountTooltip": "{percentage}% discount if paid before {date} (savings: {amount})",
      "priorityTooltip": "Invoice marked as priority",
      "editAriaLabel": "Edit invoice",
      "deleteAriaLabel": "Delete invoice"
    },
    "form": {
      "provider": "Provider",
      "invoiceNumber": "Invoice #",
      "issueDate": "Issue date",
      "dueDate": "Due date",
      "amount": "Amount",
      "description": "Description",
      "amountLockedNote": "This invoice already has payments registered, so its amount can't be changed here.",
      "excludeFromAlerts": "Exclude from overdue alerts",
      "alertExclusionReason": "Reason",
      "alertExclusionReasonPlaceholder": "E.g. payment arrangement, provider closed, etc.",
      "alertExclusionReasonHint": "Documenting the reason is recommended, though not required.",
      "discountSectionTitle": "Early-payment discount",
      "discountDays": "Discount term",
      "noDiscount": "No discount",
      "discountDaysOption": "{days} days",
      "discountPercentage": "Discount percentage",
      "discountPercentageRangeError": "Percentage must be between 0 and 100",
      "prioritySectionTitle": "Manual priority",
      "markAsPriority": "Mark as priority",
      "priorityReason": "Reason",
      "priorityReasonPlaceholder": "E.g. High turnover"
    },
    "payments": {
      "viewAriaLabel": "View payments",
      "title": "Payments for invoice {number}",
      "summary": {
        "amount": "Total amount",
        "balance": "Outstanding balance"
      },
      "historyTitle": "Payment history",
      "noPayments": "No payments have been registered for this invoice yet.",
      "fullyPaidMessage": "This invoice is already fully paid.",
      "amountExceedsBalance": "Amount can't exceed the outstanding balance ({balance})",
      "createdToast": "Payment registered successfully",
      "deletedToast": "Payment deleted successfully",
      "loadError": "Could not load payments",
      "saveError": "Could not register the payment",
      "deleteError": "Could not delete the payment",
      "deleteConfirmTitle": "Delete payment",
      "deleteConfirmMessage": "Are you sure you want to delete the payment of {amount}?",
      "table": {
        "date": "Date",
        "amount": "Amount",
        "method": "Method",
        "notes": "Notes",
        "createdBy": "Registered by",
        "deleteAriaLabel": "Delete payment"
      },
      "form": {
        "title": "Register payment",
        "amount": "Amount",
        "paymentDate": "Payment date",
        "paymentMethod": "Payment method",
        "notes": "Notes",
        "submit": "Register payment",
        "methods": {
          "transfer": "Bank transfer",
          "cash": "Cash",
          "check": "Check",
          "card": "Card",
          "other": "Other"
        }
      }
    },
    "items": {
      "viewAriaLabel": "Product detail",
      "title": "Product detail — invoice {number}",
      "detailTitle": "Purchased products",
      "noItems": "There are no products in this invoice's detail yet.",
      "addFromPreciosHint": "Products are added from the Pricing module, by selecting this invoice there.",
      "totalLabel": "Detail total",
      "loadError": "Could not load the product detail",
      "refreshAriaLabel": "Refresh status",
      "sendButton": "Send to POS",
      "resendButton": "Resend to POS",
      "sendConfirmTitle": "Send invoice to Sinutech POS",
      "sendConfirmMessage": "This will register the invoice as a purchase in the POS, with the products in the detail. Continue?",
      "resendConfirmTitle": "Resend invoice to Sinutech POS",
      "resendConfirmMessage": "This invoice was already sent to POS on {date}. If the product detail changed after that, POS will NOT reflect those changes — a resend with the same identifier is ignored as a duplicate. Resend anyway?",
      "queuedToast": "Send to POS queued — the result will show up in a few seconds",
      "sendError": "Could not queue the send to POS",
      "sentAt": "Sent on {date}",
      "posSync": {
        "never": "Not sent to POS",
        "queued": "Queued to send to POS",
        "sent": "Sent to POS",
        "failed": "Failed to send to POS"
      },
      "table": {
        "product": "Product",
        "quantity": "Quantity",
        "unitCost": "Unit cost",
        "subtotal": "Subtotal"
      }
    }
  },
  "paymentSchedules": {
    "pageTitle": "Payment Schedules",
    "statusPlaceholder": "Status",
    "allStatuses": "All statuses",
    "upcomingOnlyLabel": "Upcoming only",
    "newButton": "New schedule",
    "addTitle": "New schedule",
    "editTitle": "Edit schedule",
    "deleteConfirmTitle": "Delete schedule",
    "deleteConfirmMessage": "Are you sure you want to delete this payment schedule?",
    "createdToast": "Schedule created successfully",
    "updatedToast": "Schedule updated successfully",
    "deletedToast": "Schedule deleted successfully",
    "executedToast": "Payment executed successfully",
    "loadError": "Could not load payment schedules",
    "saveError": "Could not save the schedule",
    "deleteError": "Could not delete the schedule",
    "executeError": "Could not execute the schedule",
    "status": {
      "programado": "Scheduled",
      "ejecutado": "Executed",
      "omitido": "Skipped"
    },
    "table": {
      "scheduledDate": "Scheduled date",
      "invoice": "Invoice",
      "amount": "Scheduled amount",
      "status": "Status",
      "overdueTooltip": "Scheduled date has passed",
      "executeAriaLabel": "Execute",
      "editAriaLabel": "Edit schedule",
      "deleteAriaLabel": "Delete schedule"
    },
    "form": {
      "provider": "Provider",
      "invoice": "Invoice",
      "invoiceOption": "{number} - {provider} - Balance: {balance}",
      "selectProviderFirst": "Select a provider first",
      "noInvoicesForProvider": "This provider has no pending invoices",
      "scheduledDate": "Scheduled date",
      "scheduledAmount": "Scheduled amount",
      "amountExceedsBalanceHint": "Amount exceeds the invoice's outstanding balance ({balance}). The backend allows it, but double-check it's correct."
    },
    "execute": {
      "title": "Execute schedule",
      "description": "This will register a real payment of {amount} for invoice {number}.",
      "paymentMethod": "Payment method",
      "notes": "Notes",
      "confirm": "Execute payment"
    }
  },
  "planilla": {
    "pageTitle": "Payment Roster",
    "yearLabel": "Year",
    "yearTotalLabel": "{year} total",
    "totalLabel": "Total",
    "empty": "No pending invoices recorded for this year.",
    "loadError": "Could not load the payment roster",
    "table": {
      "provider": "Provider",
      "balance": "Outstanding balance"
    }
  },
  "inventario": {
    "pageTitle": "Inventory",
    "currentValueLabel": "Current inventory value",
    "loadError": "Could not load the inventory value",
    "form": {
      "title": "Record a movement",
      "typeLabel": "Movement type",
      "typeInitial": "Initial value",
      "typeSale": "Today's sale",
      "typePurchase": "New purchase",
      "amount": "Amount",
      "date": "Date",
      "description": "Description",
      "descriptionPlaceholder": "Optional",
      "submitButton": "Record movement",
      "saveError": "Could not record the movement",
      "successToast": {
        "initial": "Initial value recorded — added to the inventory.",
        "sale": "Today's sale recorded — subtracted from the inventory.",
        "purchase": "New purchase recorded — added to the inventory."
      }
    }
  },
  "tarjetasRegalo": {
    "pageTitle": "Gift Cards",
    "loadError": "Couldn't load gift cards",
    "searchPlaceholder": "Search by code",
    "activeOnlyLabel": "Active only",
    "newButton": "New gift card",
    "createdToast": "Gift card {code} created",
    "createError": "Couldn't create the gift card",
    "loadedToast": "Balance loaded to gift card {code}",
    "redeemedToast": "Balance redeemed from gift card {code}",
    "checkBalance": {
      "title": "Check balance",
      "codeLabel": "Gift card code",
      "button": "Check",
      "customerLabel": "Customer",
      "balanceLabel": "Available balance",
      "notFound": "No gift card was found with that code"
    },
    "form": {
      "title": "New gift card",
      "code": "Code",
      "initialAmount": "Initial amount",
      "customerName": "Customer name",
      "notes": "Notes"
    },
    "amountForm": {
      "loadTitle": "Load balance",
      "redeemTitle": "Redeem",
      "currentBalance": "Current balance: {balance}",
      "amount": "Amount",
      "notes": "Notes",
      "loadButton": "Load balance",
      "redeemButton": "Redeem",
      "loadError": "Couldn't load the balance",
      "redeemError": "Couldn't redeem the balance"
    },
    "table": {
      "code": "Code",
      "customer": "Customer",
      "balance": "Current balance",
      "status": "Status",
      "createdAt": "Created at",
      "active": "Active",
      "inactive": "Inactive",
      "loadButton": "Load balance",
      "loadAriaLabel": "Load balance",
      "redeemButton": "Redeem",
      "redeemAriaLabel": "Redeem"
    }
  },
  "clientesPuntos": {
    "pageTitle": "Customers — Loyalty Program",
    "loadError": "Couldn't load customers",
    "searchPlaceholder": "Search by name",
    "newButton": "New customer",
    "createdToast": "{name} was registered",
    "createError": "Couldn't register the customer",
    "lookup": {
      "title": "Look up customer",
      "codeLabel": "ID number or card code",
      "button": "Look up",
      "notFound": "No customer was found with that data",
      "subtitle": "ID {identification}",
      "pointsSuffix": "{points} pts"
    },
    "form": {
      "title": "New customer",
      "name": "Name",
      "identification": "ID number",
      "cardCode": "Card code",
      "phone": "Phone"
    },
    "earnForm": {
      "title": "Register purchase",
      "amount": "Purchase amount",
      "previewLabel": "Points to earn",
      "notes": "Notes",
      "submitButton": "Register purchase"
    },
    "earnedToast": "{name} earned {points} points",
    "earnError": "Couldn't register the purchase",
    "redeemedToast": "{name} redeemed \"{reward}\"",
    "redeemError": "Couldn't redeem the reward",
    "redeemModal": {
      "title": "Redeem reward",
      "subtitle": "Available balance: {balance} points",
      "confirmTitle": "You can redeem this reward!",
      "currentBalance": "Current balance",
      "cost": "Cost",
      "resultingBalance": "Resulting balance",
      "notes": "Notes",
      "confirmButton": "Confirm redemption"
    },
    "table": {
      "name": "Name",
      "identification": "ID number",
      "cardCode": "Card code",
      "phone": "Phone",
      "pointsBalance": "Points",
      "createdAt": "Registered on",
      "earnButton": "Register purchase",
      "earnAriaLabel": "Register purchase",
      "redeemButton": "Redeem reward",
      "redeemAriaLabel": "Redeem reward"
    }
  },
  "premios": {
    "pageTitle": "Rewards",
    "pageSubtitle": "The rewards catalog your customers can redeem with their accumulated points.",
    "loadError": "Couldn't load rewards",
    "newButton": "New reward",
    "createdToast": "{name} was created",
    "updatedToast": "{name} was updated",
    "deletedToast": "{name} was deleted",
    "saveError": "Couldn't save the reward",
    "deleteError": "Couldn't delete the reward",
    "deleteConfirmTitle": "Delete reward",
    "deleteConfirmMessage": "Are you sure you want to delete \"{name}\"?",
    "addTitle": "New reward",
    "editTitle": "Edit reward",
    "noRewards": "There are no rewards in the catalog yet.",
    "form": {
      "name": "Name",
      "pointsCost": "Points cost",
      "description": "Description",
      "descriptionPlaceholder": "Optional",
      "active": "Active"
    },
    "catalog": {
      "available": "Available",
      "inactive": "Inactive",
      "points": "points",
      "shortfall": "{points} points short"
    }
  },
  "configuracionPuntos": {
    "pageTitle": "Settings — Loyalty Program",
    "pageSubtitle": "Define how many pesos equal one point for the loyalty program.",
    "loadError": "Couldn't load the settings",
    "saveError": "Couldn't save the settings",
    "savedToast": "Settings updated",
    "amountPerPoint": "Amount per point",
    "amountPerPointHint": "Pesos required to earn 1 point",
    "readOnlyNotice": "Only an administrator can edit this value."
  },
  "estadoSincronizacion": {
    "pageTitle": "POS Sync Status",
    "pageSubtitle": "Review which invoices have been sent to Sinutech POS and resend the ones still queued or that failed.",
    "statusPlaceholder": "Status",
    "allStatuses": "All statuses",
    "loadError": "Could not load the sync status",
    "empty": "There are no invoices with sync attempts yet.",
    "table": {
      "invoiceNumber": "Invoice #",
      "provider": "Provider",
      "status": "Status",
      "syncedAt": "Last sync",
      "error": "Error detail",
      "resendButton": "Resend",
      "resendAriaLabel": "Resend to POS"
    }
  },
  "users": {
    "pageTitle": "Users",
    "newButton": "New user",
    "addTitle": "New user",
    "editTitle": "Edit user",
    "deactivate": "Deactivate",
    "deactivateConfirmTitle": "Deactivate user",
    "deactivateConfirmMessage": "Are you sure you want to deactivate {name}?",
    "createdToast": "{name} has been created",
    "updatedToast": "{name} has been updated",
    "deactivatedToast": "{name} has been deactivated",
    "loadError": "Could not load users",
    "saveError": "Could not save the user",
    "deactivateError": "Could not deactivate the user",
    "table": {
      "name": "Name",
      "email": "Email",
      "role": "Role",
      "status": "Status",
      "active": "Active",
      "inactive": "Inactive",
      "editAriaLabel": "Edit user",
      "deactivateAriaLabel": "Deactivate user"
    },
    "form": {
      "name": "Name",
      "email": "Email",
      "password": "Password",
      "passwordEditPlaceholder": "Leave blank to keep it unchanged",
      "passwordTooShort": "Password must be at least 8 characters",
      "role": "Role",
      "active": "Active",
      "rolesLoadError": "Could not load the available roles."
    }
  }
}
